import { FC, useEffect } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { isNil } from 'lodash';
import { cn } from 'utils/helpers';

import { useLoginContext } from '../Login';
import { LoginData } from '../../../hooks/useLogin';
import LoginNomination from './LoginNomination';
import LoginNominationVerify from './LoginNominationVerify';

const MFA: FC<Partial<LoginData>> = (props) => {
  const { method, setMfa } = useLoginContext();

  useEffect(() => {
    if (props) setMfa(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn(
        'w-full max-w-[600px]',
        'my-[88px] py-10 rounded-[6px]',
        'bg-fill-tertiary text-center',
      )}
    >
      <img
        alt="Leapify Logo"
        className="w-[137px] inline-block mx-auto"
        src={leapifyLogo}
      />
      {isNil(method) && !method ? (
        <LoginNomination />
      ) : (
        <LoginNominationVerify />
      )}
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export default MFA;
